import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import {
  InputAdornment,
  TextField as Input,
  Box,
} from '@material-ui/core';

import { useStyles } from '../login.styles';
import { Button, Typography } from '../../../components/Wrappers/Wrappers.jsx';
import VerifyButton from '../../../components/VerifyButton';
import ResendButton from '../../../components/ResendButton';
import useRecoverCodeState from './useRecoverCodeState';

function RecoverCode (props) {
  const {
    onSendCode,
    onBackToLogin,
    onResendCode,
  } = props;

  const classes = useStyles();
  const {
    code, setCode,
    pass, setPassword,
    showPassword, setShowPassword,
    resendCountdown, resetResendCountdown,
    isVerifying, isSending,
    error,
    deliveryMessage,
  } = useRecoverCodeState();

  return (
    <Box
      ml={4} mr={4}
      className={classes.forgotPasswordBox}
    >
      <Box textAlign={'left'} >
        <Typography variant={'h5'} weight={'medium'} className={classes.recoveryText}>
          Set new password
        </Typography>
        <Typography weight='light' variant={'body2'} className={classes.recoveryText}>
          {deliveryMessage}
        </Typography>
      </Box>

      <Input
        type='number'
        name='verificationCode'
        InputProps={{
          classes: {
            underline: classes.InputUnderline,
            input: classes.Input,
          },

        }}
        value={code}
        onChange={e => setCode(e.target.value)}
        margin="normal"
        placeholder="Code"
        inputProps={{ max: 10 }}

        onInput = {(e) => {
            e.target.value = e.target.value.slice(0, 6);
            // e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 6);
        }}

        error={ error.code }
        helperText={
          error.code || 'Enter recovery code'
        }

        fullWidth
        autoComplete="off"
      />

      <Input
        id="password"
        type={showPassword ? 'Text' : 'Password'}
        name="newPass"
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
                  <Box onClick={() => {
                      setShowPassword(!showPassword);
                  }}>
                    <FontAwesomeIcon icon={ showPassword ? faEye : faEyeSlash } />
                  </Box>
            </InputAdornment>
          ),

          classes: {
            underline: classes.InputUnderline,
            input: classes.Input,
          },
          autoComplete: 'new-password',
        }}
        value={pass}
        onChange={e => setPassword(e.target.value)}
        margin="normal"
        placeholder="New Password"
        error={ error.password }
        helperText={
          error.password || 'Enter password'
        }
        fullWidth
      />

      <div className={classes.formButtons}>
        <VerifyButton
          className={classes.verifyButton}
          label={'VERIFY'}
          disabled={error.disableSend}
          showProgress={isVerifying}
          onClick={() => {
            if (typeof onSendCode === 'function') {
              onSendCode({ code, password: pass });
            }
          }}
        />

        <Button
          color="primary"
          size="large"
          onClick={() => onBackToLogin()}
          className={classes.forgetButton}
        >
          Back to login
        </Button>
      </div>

      <ResendButton
          onClick={async () => {
            if (typeof onResendCode === 'function') {
              try {
                await onResendCode();
              } finally {
                resetResendCountdown();
              }
            }
          }}
          isResending={isSending}
          disabled={isSending || !!resendCountdown}
          timeRemaining={resendCountdown}
          className={classes.resendButton}
        />
  </Box>
  );
}

RecoverCode.propTypes = {
  onSendCode: PropTypes.func,
  onBackToLogin: PropTypes.func,
  onResendCode: PropTypes.func,
};

export default observer(RecoverCode);
